import axios from 'axios'
import env from '@env'

export default class SplitAPI {
}
